<tg-mobile-full-screen-dialog [fixedHeader]="true">
  <h1 class="title">
    @if (!post) {
      <span i18n="Post copy dialog|title @@postCopyDialog.title1">В какой канал скопировать пост?</span>
    }
    @if (post) {
      <span i18n="Post copy dialog|title @@postCopyDialog.title2">Пост скопирован</span>
    }
  </h1>
  <div>
    @if (err) {
      <tg-error-block [error]="err"></tg-error-block>
    }
    @if (!loading && !post) {
      <mat-nav-list>
        @for (channel of (channels$ | async); track channel) {
          <mat-list-item (click)="selectChannel(channel)">
            <div class="channel-block">
              <div>
                <img class="avatar" [src]="avatarUrl(channel)" [alt]="channel.title" />
                <div class="channel-info">
                  <h3 style="max-width: 400px; overflow: hidden">{{ channel.title }}</h3>
                  <p class="small">
                    <span> &#64;{{ channel.username }} </span>
                    <span class="mat-secondary"
                      i18n="Post copy dialog|text @@postCopyDialog.membersCount">- {{ channel.membersCount | number }}
                  подп.</span>
                  </p>
                </div>
              </div>
            </div>
          </mat-list-item>
        }
      </mat-nav-list>
    }
    @if (loading) {
      <tg-inline-loader></tg-inline-loader>
    }
    @if (post) {
      <div i18n="Post copy dialog|text @@postCopyDialog.successText">Пост скопирован в черновики канала
      <b>{{ selectedChannel.title }}</b>.
    </div>
    }
    <mat-dialog-actions>
      @if (!post) {
        <button mat-button mat-dialog-close tabindex="-1"
          i18n="Post copy dialog|button @@postCopyDialog.cancelBtn">Отмена
      </button>
      }
      @if (post) {
        <button
          mat-flat-button
          color="primary"
          [routerLink]="['channel', selectedChannel.id, 'draft', { edit: post.id }]"
          i18n="Post copy dialog|button @@postCopyDialog.editBtn"
          >
        Перейти к редактированию поста
      </button>
      }
    </mat-dialog-actions>
  </div>
</tg-mobile-full-screen-dialog>


